'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _ComponentWithUniqueIds = require('../mixins/ComponentWithUniqueIds');

var _ComponentWithUniqueIds2 = _interopRequireDefault(_ComponentWithUniqueIds);

var _UIHelpIcon = require('../icon/UIHelpIcon');

var _UIHelpIcon2 = _interopRequireDefault(_UIHelpIcon);

var _UIFormLabel = require('./UIFormLabel');

var _UIFormLabel2 = _interopRequireDefault(_UIFormLabel);

var _UICheckbox = require('../input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _PlacementConstants = require('../tooltip/PlacementConstants');

var _elements = require('../elements');

var _Functions = require('../core/Functions');

var _validateUIFormControlValidationMessage = require('./utils/validateUIFormControlValidationMessage');

var _validateUIFormControlValidationMessage2 = _interopRequireDefault(_validateUIFormControlValidationMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var sizeClasses = {
  small: 'private-form__control--small',
  medium: ''
};

/**
 * Group a form field, label, notes, and errors/alerts together
 **/
exports.default = _react2.default.createClass({
  displayName: 'UIFormControl',

  mixins: [_ComponentWithUniqueIds2.default],

  propTypes: {
    /**
     * Instructional text to display with the field label
     **/
    'aria-label': _react.PropTypes.string,

    /**
     * Display character count metadata beneath the input
     */
    characterCount: _react.PropTypes.node,

    /**
     * Pass the form input as a child. Label will be linked by provided ID, or
     * a random unique ID will be assigned to the input for linking.
     **/
    children: _react.PropTypes.node.isRequired,

    className: _react.PropTypes.string,

    /**
     * Detailed description of component. Similar to `help` but more in-depth
     **/
    description: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.bool]),

    /**
     * `true` indicates this field is in an error state
     **/
    error: _react.PropTypes.bool,

    /**
     * Message to be displayed at the bottom of the input
     *
     * By default the text is green
     * If `error` is set to `true` then the text is red
     **/
    validationMessage: _react.PropTypes.node,

    /**
     * Instructional text to display with the field label
     **/
    help: _react.PropTypes.node,

    /**
     * Class name for the <span> wrapper around the `text` prop
     **/
    helpClassName: _react.PropTypes.string,

    /**
     * `id` attribute of the input field you want label to be bound to
     *
     * By default, the `<label />` will be linked to the embedded `<input />`
     * using the `for` attribute. Use this if you need to override that behavior
     **/
    htmlFor: _react.PropTypes.string,

    /**
     * Renders a clickable <UIFormLabel /> alongside input with this text as content
     **/
    label: _react.PropTypes.node,

    /**
     * Class name for the rendered <UIFormLabel /> component
     **/
    labelClassName: _react.PropTypes.string,

    /**
     * `true` indicates the field is required and will be styled accordingly
     **/
    required: _react.PropTypes.bool.isRequired,

    /**
     * Instructional text to display with the the '?' icon and tooltip
     **/
    tooltip: _react.PropTypes.node,

    /**
     * Placement of the tooltip
     **/
    tooltipPlacement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,

    /**
     * @private
     * Enables smaller sized inputs. This is not supported for all input types.
     **/
    _size: _react.PropTypes.oneOf(Object.keys(sizeClasses))
  },

  contextTypes: {
    disabledFieldset: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      required: false,
      tooltipPlacement: 'top',
      _size: 'medium'
    };
  },
  getHtmlFor: function getHtmlFor(propValue, children) {
    var firstChild = _react.Children.only(children);

    if (propValue) {
      return propValue;
    }

    if (firstChild) {
      return this.getClosestDescendantId(firstChild) || name;
    }

    return null;
  },
  getClosestDescendantId: function getClosestDescendantId(child) {
    var element = child;
    var id = element.props.id;
    while (id == null) {
      try {
        element = _react.Children.only(element.props.children);
      } catch (e) {
        break;
      }
      id = element.props.id;
    }
    return id;
  },
  getClasses: function getClasses(_ref) {
    var className = _ref.className,
        error = _ref.error,
        label = _ref.label,
        _size = _ref._size;

    return (0, _reactUtils.classNames)('private-form__set', className, sizeClasses[_size], {
      'private-form__set--error': !!error,
      'private-form__set--no-label': !label
    });
  },
  getDerivedId: function getDerivedId(inputProps, id) {
    var IDs = Object.keys(inputProps).filter(function (prop) {
      return inputProps[prop];
    }).map(function (prop) {
      if (!inputProps[prop]) return '';
      return id + '-' + prop;
    });
    if (IDs.length > 0) return IDs.join(' ');
    return undefined;
  },
  focus: function focus() {
    if (this._input && typeof this._input.focus === 'function') {
      this._input.focus();
    }
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._input = ref;
  },
  renderValidation: function renderValidation(_ref2, renderedInputId) {
    var error = _ref2.error,
        validationMessage = _ref2.validationMessage;

    var validationClass = 'private-form__validation';

    if (validationMessage) {
      (0, _validateUIFormControlValidationMessage2.default)({ error: error, validationMessage: validationMessage });

      return _react2.default.createElement(
        _elements.Small,
        {
          className: validationClass,
          id: this.getDerivedId({ validationMessage: validationMessage }, renderedInputId),
          tabIndex: -1,
          use: error ? 'error' : 'success'
        },
        validationMessage
      );
    }

    return null;
  },
  renderHelp: function renderHelp(_ref3, renderedInputId) {
    var help = _ref3.help,
        helpClassName = _ref3.helpClassName;

    if (!help) return null;

    return _react2.default.createElement(
      'span',
      {
        className: (0, _reactUtils.classNames)('private-form__inlinehelp', helpClassName),
        id: this.getDerivedId({ help: help }, renderedInputId),
        tabIndex: -1
      },
      help
    );
  },
  renderCounter: function renderCounter(_ref4) {
    var characterCount = _ref4.characterCount;

    if (characterCount == null) return null;
    return _react2.default.createElement(
      _elements.Small,
      { className: 'private-form__counter' },
      characterCount
    );
  },
  renderDescription: function renderDescription(_ref5, renderedInputId) {
    var description = _ref5.description;

    if (!description) return null;

    return _react2.default.createElement(
      _elements.Small,
      {
        className: 'private-form__description',
        id: this.getDerivedId({ description: description }, renderedInputId),
        tabIndex: -1,
        use: 'help'
      },
      description
    );
  },
  renderInput: function renderInput(_ref6) {
    var ariaLabel = _ref6.ariaLabel,
        children = _ref6.children,
        description = _ref6.description,
        error = _ref6.error,
        help = _ref6.help,
        required = _ref6.required,
        validationMessage = _ref6.validationMessage;

    var child = _react.Children.only(children);
    var _child$props = child.props,
        name = _child$props.name,
        origRequired = _child$props.required;

    // if the child input doesn't declare `required`, pass it down

    var newRequired = required === true ? true : origRequired;
    var newError = error === true ? 'true' : undefined;

    var cloneProps = {
      'aria-label': ariaLabel,
      ref: (0, _Functions.stackRefs)('UIFormControl', child.ref, this.inputRefCallback),
      required: newRequired,
      'aria-invalid': newError,
      'aria-required': newRequired
    };

    // only add id prop if it doesn't have it already
    var descendantId = this.getClosestDescendantId(child);
    if (!descendantId) {
      cloneProps.id = this.getUniqueId(name || 'ctrl');
    }

    // only add error prop if there is an error, to avoid potential "Unknown prop" warnings
    if (error) {
      cloneProps.error = !!error;
    }

    // disable the input if we're within a disabled fieldset (#3356)
    var disabledFieldset = this.context.disabledFieldset;

    if (disabledFieldset) {
      cloneProps.disabled = true;
    }

    // aggregate IDs to pass into aria-describedby
    var newDescribedBy = this.getDerivedId({ validationMessage: validationMessage, help: help, description: description }, cloneProps.id);

    // derive ID and spread back into cloneProps
    var describedCloneProps = {
      'aria-describedby': newDescribedBy
    };

    var mergedCloneProps = _extends({}, cloneProps, describedCloneProps);

    return (0, _react.cloneElement)(child, mergedCloneProps);
  },
  renderLabel: function renderLabel(_ref7, _ref8) {
    var ariaLabel = _ref7.ariaLabel,
        children = _ref7.children,
        label = _ref7.label,
        labelClassName = _ref7.labelClassName,
        error = _ref7.error,
        htmlFor = _ref7.htmlFor,
        required = _ref7.required,
        tooltip = _ref7.tooltip,
        tooltipPlacement = _ref7.tooltipPlacement;
    var renderedInput = _ref8.renderedInput;

    if (!label && !ariaLabel && _react.Children.only(children).type !== _UICheckbox2.default) {
      _devLogger2.default.warn({
        message: "UIFormControl: For better accessibility, if you're going to omit `label`, please include an `aria-label` property.",
        key: 'UIFormControl: add aria-label'
      });
    }

    if (!label) return null;

    var renderedLabel = _react2.default.createElement(
      _UIFormLabel2.default,
      {
        className: (0, _reactUtils.classNames)(labelClassName, {
          'private-form__label--with-tooltip': !!tooltip
        }),
        error: !!error,
        htmlFor: this.getHtmlFor(htmlFor, renderedInput),
        required: required
      },
      label
    );

    return tooltip ? _react2.default.createElement(
      _UIHelpIcon2.default,
      {
        className: 'private-form__help-tooltip',
        title: tooltip,
        tooltipProps: { placement: tooltipPlacement }
      },
      renderedLabel
    ) : renderedLabel;
  },
  render: function render() {
    var _props = this.props,
        ariaLabel = _props['aria-label'],
        characterCount = _props.characterCount,
        children = _props.children,
        className = _props.className,
        description = _props.description,
        error = _props.error,
        validationMessage = _props.validationMessage,
        help = _props.help,
        helpClassName = _props.helpClassName,
        htmlFor = _props.htmlFor,
        label = _props.label,
        labelClassName = _props.labelClassName,
        required = _props.required,
        tooltip = _props.tooltip,
        tooltipPlacement = _props.tooltipPlacement,
        _size = _props._size,
        rest = _objectWithoutProperties(_props, ['aria-label', 'characterCount', 'children', 'className', 'description', 'error', 'validationMessage', 'help', 'helpClassName', 'htmlFor', 'label', 'labelClassName', 'required', 'tooltip', 'tooltipPlacement', '_size']);

    var classes = this.getClasses({
      className: className,
      error: error,
      label: label,
      _size: _size
    });
    var renderedInput = this.renderInput({
      ariaLabel: ariaLabel,
      children: children,
      description: description,
      error: error,
      help: help,
      required: required,
      validationMessage: validationMessage
    });

    var inputId = renderedInput && renderedInput.props && renderedInput.props.id;

    return _react2.default.createElement(
      'div',
      _extends({ className: classes }, rest),
      _react2.default.createElement(
        'div',
        { className: 'private-form__control-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'private-form__label-wrapper' },
          this.renderLabel({
            ariaLabel: ariaLabel,
            children: children,
            label: label,
            labelClassName: labelClassName,
            error: error,
            htmlFor: htmlFor,
            required: required,
            tooltip: tooltip,
            tooltipPlacement: tooltipPlacement
          }, { renderedInput: renderedInput }),
          this.renderHelp({ help: help, helpClassName: helpClassName }, inputId)
        ),
        _react2.default.createElement(
          'div',
          { className: 'private-form__input-wrapper' },
          renderedInput
        ),
        _react2.default.createElement(
          'div',
          { className: 'private-form__meta' },
          _react2.default.createElement(
            'div',
            { className: 'private-form__messages' },
            this.renderValidation({ error: error, validationMessage: validationMessage }, inputId)
          ),
          this.renderCounter({ characterCount: characterCount })
        ),
        this.renderDescription({ description: description }, inputId)
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/form/UIFormControl.js
// module id = 336
// module chunks = 0